import { apiPostPut } from "../api/api_methods";

// Function to get browser information
export const getBrowserInfo = () => {
  const userAgent = navigator.userAgent;
  let browser = "Unknown";
  
  if (userAgent.includes("Chrome")) {
    browser = "Chrome";
  } else if (userAgent.includes("Firefox")) {
    browser = "Firefox";
  } else if (userAgent.includes("Safari")) {
    browser = "Safari";
  } else if (userAgent.includes("Edge")) {
    browser = "Edge";
  } else if (userAgent.includes("Opera")) {
    browser = "Opera";
  }
  
  return {
    browser,
    userAgent,
    platform: navigator.platform,
    language: navigator.language,
    cookieEnabled: navigator.cookieEnabled,
    onLine: navigator.onLine,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
  };
};

// Function to get device details
export const getDeviceDetails = () => {
  return {
    deviceName: navigator.userAgent,
    browser: getBrowserInfo().browser,
    platform: navigator.platform,
    language: navigator.language,
    cookieEnabled: navigator.cookieEnabled,
    onLine: navigator.onLine,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
  };
};

// Function to get IP address and location
export const getLocationInfo = async () => {
  try {
    // Add timeout to prevent hanging
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 second timeout
    
    const response = await fetch("https://ipapi.co/json/", {
      signal: controller.signal
    });
    
    clearTimeout(timeoutId);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    return {
      ipAddress: data.ip || "Not available",
      location: `${data.city || ""}, ${data.region || ""}, ${data.country_name || ""}`.trim().replace(/^,\s*/, "").replace(/,\s*$/, "") || "Not available",
      network: data.org || "Not available",
      longitude: data.longitude || null,
      latitude: data.latitude || null,
      postal: data.postal || "Not available",
      timezone: data.timezone || "Not available",
    };
  } catch (error) {
    console.error("Error fetching location info:", error);
    return {
      ipAddress: "Not available",
      location: "Not available",
      network: "Not available",
      longitude: null,
      latitude: null,
      postal: "Not available",
      timezone: "Not available",
    };
  }
};

// Function to get MAC address (Note: This is not possible in browsers for security reasons)
export const getMacAddress = () => {
  return "Not available (browser restriction)";
};

// Function to collect all system metrics
export const collectSystemMetrics = async (testResults) => {
  try {
    const deviceInfo = getDeviceDetails();
    const locationInfo = await getLocationInfo();
    
    const metrics = {
      camera: testResults.camera || false,
      mic: testResults.mic || false,
      speaker: testResults.speaker || false,
      internet: testResults.internet || 0,
      clipboard: testResults.clipboard || false,
      deviceName: deviceInfo.deviceName,
      browser: deviceInfo.browser,
      ipAddress: locationInfo.ipAddress,
      location: locationInfo.location,
      macAddress: getMacAddress(),
      network: locationInfo.network,
      longitude: locationInfo.longitude,
      latitude: locationInfo.latitude,
      postal: locationInfo.postal,
      acceptance: testResults.acceptance || false,
      // Additional device info
      platform: deviceInfo.platform,
      language: deviceInfo.language,
      cookieEnabled: deviceInfo.cookieEnabled,
      onLine: deviceInfo.onLine,
      screenWidth: deviceInfo.screenWidth,
      screenHeight: deviceInfo.screenHeight,
      windowWidth: deviceInfo.windowWidth,
      windowHeight: deviceInfo.windowHeight,
      timezone: locationInfo.timezone,
    };
    
    return metrics;
  } catch (error) {
    console.error("Error collecting system metrics:", error);
    throw error;
  }
};

// Function to store metrics in backend
export const storeSystemMetrics = async (metrics) => {
  try {
    // Validate required fields
    const requiredFields = ['camera', 'mic', 'speaker', 'internet', 'clipboard', 'deviceName', 'browser', 'acceptance'];
    const missingFields = requiredFields.filter(field => metrics[field] === undefined);
    
    if (missingFields.length > 0) {
      console.error("Missing required fields:", missingFields);
      return null;
    }
    
    console.log("Sending metrics to API:", metrics);
    const response = await apiPostPut(metrics, "/interview-metrics/add-metrics", "POST");
    
    if (response.status === 200 && response.body?.success) {
      return response.body?.data?._id || null;
    } else {
      console.error("Failed to store system metrics:", response.body?.message);
      return null;
    }
  } catch (error) {
    console.error("Error storing system metrics:", error);
    return null;
  }
};

// Main function to collect and store metrics
export const collectAndStoreMetrics = async (testResults) => {
  try {
    console.log("Starting system metrics collection...");
    const metrics = await collectSystemMetrics(testResults);
    console.log("Collected metrics:", metrics);
    
    const metricsId = await storeSystemMetrics(metrics);
    console.log("Stored metrics with ID:", metricsId);
    
    return metricsId;
  } catch (error) {
    console.error("Error in collectAndStoreMetrics:", error);
    return null;
  }
}; 